import React from 'react'

import { ReactComponent as BonhommeIcon } from 'assets/icons/user-profile-v1.svg'
import { ReactComponent as NotificationIcon } from 'assets/icons/alarm-bell.svg'
import { ReactComponent as AlertIcon } from 'assets/icons/alert-triangle.svg'
import { ReactComponent as MenuIcon } from 'assets/icons/menu.svg'
import { ReactComponent as ExpandLessIcon } from 'assets/icons/expand-less.svg'
import { ReactComponent as ExpandMoreIcon } from 'assets/icons/expand-more.svg'
import { ReactComponent as AssesstmentIcon } from 'assets/icons/assessment.svg'
import { ReactComponent as ReceiptIcon } from 'assets/icons/receipt.svg'
import { ReactComponent as FolderIcon } from 'assets/icons/folder.svg'
import { ReactComponent as ExchangeIcon } from 'assets/icons/exchange.svg'
import { ReactComponent as HomeIcon } from 'assets/icons/home.svg'
import { ReactComponent as HouseIcon } from 'assets/icons/house-3.svg'
import { ReactComponent as FactureIcon } from 'assets/icons/facture.svg'
import { ReactComponent as DownloadIcon } from 'assets/icons/download.svg'
import { ReactComponent as DocumentIcon } from 'assets/icons/document.svg'
import { ReactComponent as BuildingIcon } from 'assets/icons/building.svg'
import { ReactComponent as MapIcon } from 'assets/icons/map.svg'
import { ReactComponent as HierarchyIcon } from 'assets/icons/hierarchy.svg'
import { ReactComponent as SuccessIcon } from 'assets/icons/success.svg'
import { ReactComponent as ArrowUpIcon } from 'assets/icons/arrow-up.svg'
import { ReactComponent as ArrowDownIcon } from 'assets/icons/arrow-down.svg'
import { ReactComponent as ArrowLeftIcon } from 'assets/icons/arrow-left.svg'
import { ReactComponent as ArrowRightIcon } from 'assets/icons/arrow-right-1.svg'
import { ReactComponent as ArrowRightShortIcon } from 'assets/icons/arrow-right-short.svg'
import { ReactComponent as FilterIcon } from 'assets/icons/filter.svg'
import { ReactComponent as PlusIcon } from 'assets/icons/plus.svg'
import { ReactComponent as MinusIcon } from 'assets/icons/minus.svg'
import { ReactComponent as EyeIcon } from 'assets/icons/eye.svg'
import { ReactComponent as EyeFullIcon } from 'assets/icons/eye-full.svg'
import { ReactComponent as SendEmailIcon } from 'assets/icons/send-email.svg'
import { ReactComponent as CloseIcon } from 'assets/icons/close.svg'
import { ReactComponent as CashPaymentBillIcon } from 'assets/icons/cash-payment-bill.svg'
import { ReactComponent as DownloadBottomIcon } from 'assets/icons/download-bottom.svg'
import { ReactComponent as FloppyDiskIcon } from 'assets/icons/floppy-disk.svg'
import { ReactComponent as CoordonneesIcon } from 'assets/icons/coordonnees.svg'
import { ReactComponent as BinIcon } from 'assets/icons/bin.svg'
import { ReactComponent as ReloadIcon } from 'assets/icons/diagram-round.svg'
import { ReactComponent as SynchronizeIcon } from 'assets/icons/synchronize-arrow-2.svg'
import { ReactComponent as GridIcon } from 'assets/icons/grid.svg'
import { ReactComponent as ListIcon } from 'assets/icons/list.svg'
import { ReactComponent as CheckIcon } from 'assets/icons/check.svg'
import { ReactComponent as CircleCheckIcon } from 'assets/icons/check-circle-1.svg'
import { ReactComponent as AddSquareIcon } from 'assets/icons/add-square.svg'
import { ReactComponent as AddCircleIcon } from 'assets/icons/add-circle.svg'
import { ReactComponent as AddCircleFillIcon } from 'assets/icons/add-circle-fill.svg'
import { ReactComponent as SubstractSquareIcon } from 'assets/icons/substract-square.svg'
import { ReactComponent as UploadFile } from 'assets/icons/upload-file.svg'
import { ReactComponent as IconRight } from 'assets/icons/icon-right.svg'
import { ReactComponent as StepAfter } from 'assets/icons/step-after.svg'
import { ReactComponent as StepBefore } from 'assets/icons/step-before.svg'
import { ReactComponent as InfoCircleIcon } from 'assets/icons/info-circle.svg'
import { ReactComponent as InfoCircleFullIcon } from 'assets/icons/info-circle-full.svg'
import { ReactComponent as NavigationRightCircleIcon } from 'assets/icons/navigation-right-circle.svg'
import { ReactComponent as PencilWriteIcon } from 'assets/icons/pencil-write.svg'
import { ReactComponent as Users } from 'assets/icons/users.svg'
import { ReactComponent as PencilWriteBold } from 'assets/icons/pencil-write-bold.svg'
import { ReactComponent as PerformanceIncrease } from 'assets/icons/performance-increase.svg'
import { ReactComponent as FileUpload } from 'assets/icons/file-upload.svg'
import { ReactComponent as IndicEnviIcon } from 'assets/icons/picto_mesindicateurs_environnementaux.svg'
import { ReactComponent as CO2Icon } from 'assets/icons/picto_co2.svg'
import { ReactComponent as CO2BoldIcon } from 'assets/icons/picto_co2_bold.svg'
import { ReactComponent as CarIcon } from 'assets/icons/picto_voiture.svg'
import { ReactComponent as DiplomaIcon } from 'assets/icons/picto_diplome.svg'
import { ReactComponent as CommonFileTextIcon } from 'assets/icons/common-file-text.svg'
import { ReactComponent as CommonFileTextDownloadIcon } from 'assets/icons/common-file-text-download.svg'
import { ReactComponent as EmailActionSync } from 'assets/icons/email-action-sync-1.svg'
import { ReactComponent as EmailActionSend } from 'assets/icons/email-action-send-2.svg'
import { ReactComponent as Delete } from 'assets/icons/delete-1.svg'
import { ReactComponent as DataTransferHorizontal } from 'assets/icons/data-transfer-horizontal.svg'
import { ReactComponent as CommonFileQuestion } from 'assets/icons/common-file-question.svg'
import { ReactComponent as DataFileBarsInfo } from 'assets/icons/data-file-bars-info.svg'
import { ReactComponent as PDF } from 'assets/icons/pdf.svg'
import { ReactComponent as Envelope } from 'assets/icons/envelope.svg'
import { ReactComponent as ExternalLink } from 'assets/icons/external-link.svg'
import { ReactComponent as SearchIcon } from 'assets/icons/search-alternate.svg'
import { ReactComponent as Animation } from 'assets/icons/offers/animation.svg'
import { ReactComponent as AuditDiag } from 'assets/icons/offers/audit-diag.svg'
import { ReactComponent as BilanGesReporting } from 'assets/icons/offers/bilan-ges-reporting.svg'
import { ReactComponent as BoxDEEE } from 'assets/icons/offers/box-deee.svg'
import { ReactComponent as CollecteTri } from 'assets/icons/offers/collecte-tri-valorisation.svg'
import { ReactComponent as Formation } from 'assets/icons/offers/formation.svg'
import { ReactComponent as MymonitorCompacteur } from 'assets/icons/offers/mymonitor-compacteur.svg'
import { ReactComponent as SupportsCom } from 'assets/icons/offers/supports-com.svg'
import { ReactComponent as TextilesProfessionnels } from 'assets/icons/offers/textiles-professionnels.svg'

const ICONS: Record<string, React.FC<React.SVGProps<SVGSVGElement>>> = {
  addCircle: AddCircleIcon,
  addCircleFill: AddCircleFillIcon,
  addSquare: AddSquareIcon,
  alert: AlertIcon,
  animation: Animation,
  arrowDown: ArrowDownIcon,
  arrowLeft: ArrowLeftIcon,
  arrowRight: ArrowRightIcon,
  arrowRightShort: ArrowRightShortIcon,
  arrowUp: ArrowUpIcon,
  assesstment: AssesstmentIcon,
  auditDiag: AuditDiag,
  bilanGesReporting: BilanGesReporting,
  bin: BinIcon,
  bonhomme: BonhommeIcon,
  boxDeee: BoxDEEE,
  building: BuildingIcon,
  carIcon: CarIcon,
  cashPaymentBill: CashPaymentBillIcon,
  check: CheckIcon,
  circleCheck: CircleCheckIcon,
  close: CloseIcon,
  co2BoldIcon: CO2BoldIcon,
  co2Icon: CO2Icon,
  collecteTri: CollecteTri,
  commonFileQuestion: CommonFileQuestion,
  commonFileText: CommonFileTextIcon,
  commonFileTextDownload: CommonFileTextDownloadIcon,
  coordonnees: CoordonneesIcon,
  dataTransferHorizontal: DataTransferHorizontal,
  dataFileBarsInfo: DataFileBarsInfo,
  delete: Delete,
  diplomaIcon: DiplomaIcon,
  document: DocumentIcon,
  download: DownloadIcon,
  downloadBottom: DownloadBottomIcon,
  emailActionSend: EmailActionSend,
  emailActionSyn: EmailActionSync,
  envelope: Envelope,
  exchange: ExchangeIcon,
  expandLess: ExpandLessIcon,
  expandMore: ExpandMoreIcon,
  externalLink: ExternalLink,
  eye: EyeIcon,
  eyeFull: EyeFullIcon,
  facture: FactureIcon,
  fileUpload: FileUpload,
  filter: FilterIcon,
  floppyDisk: FloppyDiskIcon,
  folder: FolderIcon,
  formation: Formation,
  grid: GridIcon,
  hierarchy: HierarchyIcon,
  home: HomeIcon,
  house: HouseIcon,
  iconRight: IconRight,
  indicEnvIcon: IndicEnviIcon,
  infoCircle: InfoCircleIcon,
  infoCircleFull: InfoCircleFullIcon,
  list: ListIcon,
  map: MapIcon,
  menu: MenuIcon,
  minus: MinusIcon,
  mymonitorCompacteur: MymonitorCompacteur,
  navigationRightCircle: NavigationRightCircleIcon,
  notification: NotificationIcon,
  pdf: PDF,
  pencilWrite: PencilWriteIcon,
  pencilWriteBold: PencilWriteBold,
  performanceIncrease: PerformanceIncrease,
  plus: PlusIcon,
  receipt: ReceiptIcon,
  reload: ReloadIcon,
  sendEmail: SendEmailIcon,
  search: SearchIcon,
  stepAfter: StepAfter,
  stepBefore: StepBefore,
  substractSquare: SubstractSquareIcon,
  success: SuccessIcon,
  supportsCom: SupportsCom,
  synchronize: SynchronizeIcon,
  textilesProfessionnels: TextilesProfessionnels,
  uploadFile: UploadFile,
  users: Users,
}

interface Props {
  name: string
  className?: string
  color?: string
}

const SvgIcon: React.FC<Props> = ({ name, className, color }: Props) => {
  if (!Object.prototype.hasOwnProperty.call(ICONS, name)) return null
  const Icon = ICONS[name]
  const Color = color ? { color } : undefined
  return <Icon className={className} style={Color} />
}

SvgIcon.defaultProps = {
  className: '',
  color: undefined,
}

export default SvgIcon
